
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"15","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.474 0h7.368c.55.265 1.403.27 2.105 1.071.658.695.853 2.165 1.053 2.143-.2.022 0 1.748 0 3.215V8.57c0 1.46-.2 3.186 0 3.215-.2-.029-.395 1.441-1.053 2.143-.702.795-1.555.799-2.105 1.071-2.64-.007-6.842 0-6.316 0-.526 0-5.726-.05-7.368 0-.403-.303-1.402-.276-2.105-1.071C.395 13.227.2 11.757 0 11.786c.2-.029 0-1.755 0-3.215V6.43c0-1.467.2-3.193 0-3.215.2.022.395-1.448 1.053-2.143C1.756.27 2.608.265 3.158 0h6.316zM8.42 4.286v6.428L13.684 7.5 8.421 4.286z","fill":"#70767C","fill-rule":"evenodd"}})])
      }
    
      }
    